import { supabase } from "./supabase";
import { resizeImage } from "./imageResize";

const BUCKET = "tenant-logos";
const MAX_WIDTH = 512;
type Variant = "light" | "dark";

const EXT_BY_TYPE: Record<string, string> = {
  "image/png":  "png",
  "image/jpeg": "jpg",
  "image/webp": "webp",
  "image/svg+xml": "svg",
};

export async function uploadLogo(
  tenantId: string,
  variant: Variant,
  file: File,
): Promise<string> {
  const ext = EXT_BY_TYPE[file.type];
  if (!ext) throw new Error(`Unsupported logo type: ${file.type}`);

  const blob = file.type === "image/svg+xml" ? file : await resizeImage(file, MAX_WIDTH);
  const path = `${tenantId}/logo-${variant}.${ext}`;

  const { error } = await supabase.storage.from(BUCKET).upload(path, blob, {
    contentType: file.type,
    upsert: true,
  });
  if (error) throw new Error(`Upload failed: ${error.message}`);

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(path);
  return data.publicUrl;
}

export async function deleteLogo(tenantId: string, variant: Variant): Promise<void> {
  const candidates = Object.values(EXT_BY_TYPE).map((ext) => `${tenantId}/logo-${variant}.${ext}`);
  await supabase.storage.from(BUCKET).remove(candidates);
}
